import { Link } from 'react-router-dom';

import EmptyIcon from '@/assets/icons/empty.svg';
import { Typography, type TypographyVariant } from '@/components/ui/typography';
import { cn } from '@/utils/classnames';

import { Button } from './button';

interface EmptyStateProps {
  className?: string;
  icon?: string;
  iconClassName?: string;
  header: string;
  description: string;
  descriptionVariant?: TypographyVariant;
  descriptionClassName?: string;
  buttonIcon?: string;
  buttonTitle?: string;
  onClick?: () => void;
  isDisabled?: boolean;
  link?: string;
}

export function EmptyState({
  className,
  icon,
  iconClassName,
  header,
  description,
  descriptionVariant = 'subtitle1',
  descriptionClassName,
  buttonIcon,
  buttonTitle,
  onClick,
  isDisabled,
  link,
}: EmptyStateProps) {
  const showButton = (onClick || link || isDisabled) && buttonTitle;

  const buttonContent = (
    <>
      {buttonIcon && <img src={buttonIcon} alt="Error" />}
      {buttonTitle}
    </>
  );

  return (
    <div
      className={cn(
        'mx-auto flex w-[300px] flex-1 flex-col items-center justify-center gap-2',
        className,
      )}
    >
      <img
        src={icon ?? EmptyIcon}
        alt=""
        className={cn('shrink-0', iconClassName)}
      />
      <Typography variant="body2">{header}</Typography>
      <Typography
        variant={descriptionVariant}
        className={cn('text-center', descriptionClassName)}
      >
        {description}
      </Typography>

      {showButton && (
        <Button onClick={onClick} className="mt-2" disabled={isDisabled}>
          {link ? <Link to={link}>{buttonContent}</Link> : buttonContent}
        </Button>
      )}
    </div>
  );
}
